import { FC } from 'react'
import { Modal } from 'Components/Modal/Modal'
import { CreateCountryForm } from './CreateCountryForm'

type CreateCountryModalProps = {
  showModal: boolean
  setShowModal: (a: boolean) => void
}

export const CreateCountryModal: FC<CreateCountryModalProps> = ({ showModal, setShowModal }) => {
  return (
    <Modal showModal={showModal} setShowModal={setShowModal} maxWidth={800} minWidth={800} overflow>
      <CreateCountryForm closeModal={() => setShowModal(false)} />
    </Modal>
  )
}
